const KEY = 'cookie_consent';
const EXPIRY_MS = 365 * 24 * 60 * 60 * 1000;

export type ConsentState = {
  essential: true;
  analytics: boolean;
  marketing: boolean;
  decided: boolean;
  timestamp: number;
};

export function getConsent(): ConsentState | null {
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) return null;
    const state = JSON.parse(raw) as ConsentState;
    if (Date.now() - state.timestamp > EXPIRY_MS) {
      localStorage.removeItem(KEY);
      return null;
    }
    return state;
  } catch {
    return null;
  }
}

export function saveConsent(analytics: boolean, marketing: boolean): ConsentState {
  const state: ConsentState = {
    essential: true,
    analytics,
    marketing,
    decided: true,
    timestamp: Date.now(),
  };
  localStorage.setItem(KEY, JSON.stringify(state));
  applyGA4Consent(analytics, marketing);
  return state;
}

export function acceptAll(): ConsentState {
  return saveConsent(true, true);
}
export function rejectAll(): ConsentState {
  return saveConsent(false, false);
}

export function applyGA4Consent(analytics: boolean, marketing: boolean) {
  if (typeof window === 'undefined') return;
  const gtag = (window as any).gtag as ((...args: unknown[]) => void) | undefined;
  if (!gtag) return;
  gtag('consent', 'update', {
    analytics_storage: analytics ? 'granted' : 'denied',
    ad_storage: marketing ? 'granted' : 'denied',
    ad_user_data: marketing ? 'granted' : 'denied',
    ad_personalization: marketing ? 'granted' : 'denied',
  });
}
